import axios from 'axios';
import { API_ENDPOINTS } from './constants';

export const apiClient = axios.create({
  baseURL: API_ENDPOINTS.BASE_URL,
  withCredentials: false
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('vediluxe_token');

  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Clear expired/invalid token on 401 — app falls back to guest mode
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && localStorage.getItem('vediluxe_token')) {
      localStorage.removeItem('vediluxe_token');
    }
    return Promise.reject(error);
  }
);

